import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { contentStyles, h4, paragraphSmall, cardHeadingUnderline, cardHeadingChevron } from '@helpers/typography';
import styled from 'styled-components';
import SimpleImage from '../SimpleImage/SimpleImage';
const Container = styled.article `
  --bgColor: ${brand.white};
  --fgColor: ${brand.black};
  border-radius: 8px;
  box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.08);
  display: block;
  overflow: hidden; 
  background: var(--bgColor);
  color: var(--fgColor);
  height: 100%;
`;
const Link = styled.a `
  display: flex;
  color: currentColor;
  flex-direction: column;
  height: 100%;
  text-decoration: none;
`;
const ImageWrapper = styled.div `
  position: relative;
  aspect-ratio: 360 / 226;
  overflow: hidden;
`;
const Image = styled(SimpleImage) `
  width: 100%;
  height: 100%;
  object-fit: contain; 
`;
const ContentWrapper = styled.div `
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: 18px;

  @media ${from(Device.TabletLarge)} {
   padding: 24px 24px 32px;
  }
`;
const Title = styled.h3 `
  ${h4}
  ${cardHeadingUnderline}
  ${({ $isLink }) => $isLink && cardHeadingChevron}
`;
const Summary = styled.div `
  ${contentStyles};
  ${paragraphSmall};
  margin-bottom: 0;
`;
const CtaWrapper = styled.div `
  display: block;
  margin-top: auto;
  padding-top: 22px;

  @media ${from(Device.TabletLarge)} {
    padding-top: 48px;
  }
`;
const ApproachCardStyles = {
    Container,
    ContentWrapper,
    CtaWrapper,
    Image,
    ImageWrapper,
    Link,
    Summary,
    Title,
};
export default ApproachCardStyles;
